export default class CriteriaListViewCtrl {
  constructor ($scope, $resource, $stateParams, WorkPlanParametrizationSrv, $mdDialog, $timeout, $state,$window, $filter) {
  // CONSTANTS
    const criteriaListVM = this
    const categoryId = $stateParams.categoryId
    criteriaListVM.allLists = []
    criteriaListVM.criteriaList = {}
    criteriaListVM.workplans = []
    criteriaListVM.associations = {}
    criteriaListVM.workplansInitiated = []
    criteriaListVM.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
    if (categoryId === '1') {
      criteriaListVM.mainLabel = 'Criterios de revisión/aprobación'
      criteriaListVM.gradCriteriaClass = 'grad-1'
    } else {
      criteriaListVM.mainLabel = 'Criterios de evaluación'
      criteriaListVM.gradCriteriaClass = 'grad-3'
    }

  // VARIABLES
    criteriaListVM.viewLoaded = true

  // METHODS
    criteriaListVM.contains = contains
    criteriaListVM.updateView = updateView
    criteriaListVM.updateSearchView = updateSearchView
    criteriaListVM.numerize = numerize
    criteriaListVM.hasError = hasError
    criteriaListVM.showErrorMessages = showErrorMessages
    criteriaListVM.returnBack = returnBack
    criteriaListVM.checkIsInicializated = checkIsInicializated

  // MODALS
    criteriaListVM.createCriteria = createCriteria
    criteriaListVM.associateCriteria = associateCriteria
    criteriaListVM.associatedPlans = associatedPlans
    criteriaListVM.confirmDeleteCriteriaList = confirmDeleteCriteriaList

    function activate (id) {
      return getCriteriaListData(id).then(getWorkplans(id))
    }

  // SERVICES
    function getCriteriaListData (id) {
      return WorkPlanParametrizationSrv.criteriaListService.get().$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
          if (id === '1') {
            criteriaListVM.criteriaList = dataReturn.data.crt1
            dataReturn.data.crt1.forEach((list) => {
              criteriaListVM.allLists.push(list)
            })
            dataReturn.data.crt2.forEach((list) => {
              criteriaListVM.allLists.push(list)
            })
          } else {
            criteriaListVM.criteriaList = dataReturn.data.crt2
            dataReturn.data.crt2.forEach((list) => {
              criteriaListVM.allLists.push(list)
            })
            dataReturn.data.crt1.forEach((list) => {
              criteriaListVM.allLists.push(list)
            })
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    }

    function getWorkplans (id) {
      let header = {categoryId: id}
      return WorkPlanParametrizationSrv.workplanByCategory.get(header).$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
          let workPlansAdd = dataReturn.data
          workPlansAdd.forEach((plan) => {
              delete plan.dt_start_date
              delete plan.category
              criteriaListVM.workplans.push(plan)
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    }

    function associateToDefaultSet (workplan) {
      for (var pos in criteriaListVM.criteriaList) {
        if (criteriaListVM.criteriaList[pos].is_editable === 'false') {
          if (!Array.isArray(workplan)) {
            criteriaListVM.criteriaList[pos].workplans.push(workplan)
          } else {
            criteriaListVM.criteriaList[pos].workplans = criteriaListVM.criteriaList[pos].workplans.concat(workplan)
          }
          break
        }
      }
    }

    function returnBack () {
      window.history.back()
    }

  // METHODS
    function hasError (input) {
      if (typeof input!=='undefined' && input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      if(typeof input!=='undefined')
        return input.$dirty || input.$touched
    }

    function contains (collection, value) {
      for (var i = 0; i < collection.length; i++) {
        if (collection[i].id_work_plan === value.id_work_plan) {
          return true
        }
      }
      return false
    }

    function updateView () {
      criteriaListVM.viewLoaded = true
      $state.reload()
        // $window.location.href =  $window.location;
      criteriaListVM.viewLoaded = false
      $timeout(() => {
        criteriaListVM.viewLoaded = true
      }, 100)
    }

    function updateSearchView () {
      criteriaListVM.viewLoaded = true
      criteriaListVM.viewLoaded = false
      $timeout(() => {
        criteriaListVM.viewLoaded = true
      }, 100)
    }

    function numerize (string) {
      return parseInt(string, 10)
    }

  // MODAL DEFINITIONS
    function createCriteria (idList) { // CRITERIA EDITS ALSO INSIDE
      let updateView = criteriaListVM.updateView
      let criteriaList = criteriaListVM.criteriaList
      let numerize = criteriaListVM.numerize
      let hasError = criteriaListVM.hasError
      let showErrorMessages = criteriaListVM.showErrorMessages
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.criteriaList = criteriaList
          $scope.numerize = numerize
          $scope.updateView = updateView
          $scope.deletedItems = []
          $scope.hasError = hasError
          $scope.showErrorMessages = showErrorMessages
          $scope.description = ''
          $scope.name = ''
          if ($stateParams.categoryId === '1') {
            $scope.mainLabel = ' de revisión/aprobación'
          } else {
            $scope.mainLabel = ' de evaluación'
          }

          $scope.isDisabled = (form) => {
            if (typeof $scope.items !=='undefined' && $scope.items.length > 0 && typeof form!=='undefined' && !form.$invalid) {
              return false
            }
            return true
          }

          $scope.requireDetails = (form) => {
            if (typeof $scope.ds_description!=='undefined' && $scope.ds_description.length > 0 && typeof form!=='undefined' && !form.$invalid) {
              return false
            }
            return true
          }

          function updateCreateCriteriaModal (idList) {
            $scope.newList = {} // variable to transport new list
            if (!idList) {
              $scope.items = []
              $scope.workplans = []
              $scope.category = $stateParams.categoryId // To preselect the category options
              $scope.position = 0
            } else {
              for (var pos in $scope.criteriaList) {
                if (idList === $scope.criteriaList[pos].id_list) {
                  $scope.positionInList = pos
                  $scope.idList = idList
                  $scope.name = $scope.criteriaList[pos].list_name
                  $scope.description = $scope.criteriaList[pos].ds_description
                  $scope.category = $scope.criteriaList[pos].id_type_list
                  $scope.items = []
                  for(var i = 0 ; i < $scope.criteriaList[pos].items.length; i++){
                    var objElem = {
                      id_lists_item: $scope.criteriaList[pos].items[i].id_lists_item,
                      lists_item_name: $scope.criteriaList[pos].items[i].lists_item_name,
                      nm_order: $scope.criteriaList[pos].items[i].nm_order,
                      ds_description: $scope.criteriaList[pos].items[i].ds_description,
                      is_active: $scope.criteriaList[pos].items[i].is_active
                    }
                    $scope.items.push(objElem)
                  }
                  $scope.position = $scope.criteriaList[pos].items.length
                  $scope.workplans = $scope.criteriaList[pos].workplans
                  $scope.criteriaList[pos].is_editable == 1 ? $scope.criterio = '' : $scope.criterio = true
                  // $scope.criterio= $scope.criteriaList[pos].is_editable
                  break
                }
              }
            }
          }

          updateCreateCriteriaModal(idList)
          $scope.addToItems = (item, items, criteriaDescription) => {
            if (item && !itemIsAlreadyAdded(item, items, criteriaDescription)) {
              if (!items[$scope.position]) {
                items[$scope.position] = {}
              }

              items[$scope.position].lists_item_name = item
              items[$scope.position].nm_order = $scope.position + 1
              items[$scope.position].ds_description = criteriaDescription
              items[$scope.position].is_active = 1

              $scope.position = items.length
              $scope.item = ''
              $scope.ds_description = ''
              $scope.addCriteria.$setPristine()
              return items
            }
          }
          $scope.editItem = (item, items, criteriaDescription) => {
            $scope.item = item.lists_item_name
            $scope.ds_description = item.ds_description
            $scope.position = items.indexOf(item)
          }

          $scope.removeFromItems = (item, items, criteriaDescription) => {
              let workplansInitiated = []
              var nameCriterio = item.lists_item_name

              //Revisa si tiene planes activos
              var tieneActivos = false;
              
              var workpl = []; //Empty array
              workpl = $scope.workplans;
              
              var dateToday = $filter('date') (new Date(), 'yyyy-MM-dd');
              for (var i=0; i<workpl.length; i++) {
                var dateStart = $filter('date') (workpl[i].start_date, 'yyyy-MM-dd');        

                //Si la fecha es menor o igual a fecha actual, entonces está activo y no se puede eliminar.
                if (dateStart <= dateToday) {
                  tieneActivos = true;
                  workplansInitiated.push(workpl[i]);
                }
              }

              if(tieneActivos === false)
              {
                  var index = items.indexOf(item)
                  if (index > -1) {
                    if(typeof items[index].id_lists_item!=='undefined'){
                      items[index].is_active = 0
                      $scope.deletedItems.push(items[index])
                    }
                    items.splice(index, 1)
                  }

                  items.forEach((item) => {
                    if (items.indexOf(item) >= index) {
                      item.nm_order = item.nm_order - 1
                    }
                  })
                  $scope.position = items.length
                  return items
              }
              else
              {        
                //Show modal with validation message
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {                     
                      $scope.nameCriterio = nameCriterio
                      $scope.workplansInitiated = workplansInitiated
                      $scope.close = () => {
                        $mdDialog.hide()
                      }
                    }],
                    template: require('./noDesasociarPlanInitiatedModal.html'),
                    clickOutsideToClose: true
                  })
              }
          }


          $scope.close = () => {
            $mdDialog.hide()
            $state.reload()
          }

          $scope.createCriteriaList = (idList) => {
            $scope.isDisabled = (form) => {
              return true
            }
            typeof $scope.criterio === 'undefined' || $scope.criterio == '' ? $scope.criterio = 1 : $scope.criterio = 0
            $scope.newList = {
              list_name: $scope.name,
              is_visible: 1,
              ds_description: $scope.description,
              is_editable: $scope.criterio,
              id_type_list: $scope.category,
              items: $scope.items,
              workplans: $scope.workplans,
              criterio: $scope.criterio
            }
            if (idList) { // editing
              $scope.newList['id_list'] = idList
              var data = angular.copy($scope.newList)
              data['items'] = data['items'].concat($scope.deletedItems)
              WorkPlanParametrizationSrv.updateCriteria.update(data).$promise.then((dataReturn) => {
                if (dataReturn.status === true) {
                  $scope.criteriaList[$scope.positionInList] = $scope.newList
                  $mdDialog.hide()
                  updateView()
                }
                $scope.isDisabled = (form) => {
                  return false
                }
              })
            } else {
              WorkPlanParametrizationSrv.createCriterias.create($scope.newList)
              .$promise.then((dataReturn) => {
                if (dataReturn.status === true) {
                  $mdDialog.hide()
                  $state.reload()
                }
                $scope.isDisabled = (form) => {
                  return false
                }
              })
            }
          }
        }],
        template: require('./createCriteriaModal.html'),
        clickOutsideToClose: true,
        preserveScope: true
      })
    }

    function associateCriteria (list) {
      let criteriaList = criteriaListVM.allLists
      let workplans = criteriaListVM.workplans
      let numerize = criteriaListVM.numerize
      let contains = criteriaListVM.contains
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function associateCriteriaModal ($scope, $mdDialog) {
          $scope.criteriaList = criteriaList
          $scope.workplans = workplans
          $scope.numerize = numerize
          $scope.contains = contains
          $scope.category = list.id_type_list // To preselect the category options
          $scope.listing = list
          $scope.isDisabled = false
          $scope.close = close
          $scope.postAssociation = postAssociation
          if (categoryId === '1') {
            $scope.mainLabel = ' revisión/aprobación'
          } else {
            $scope.mainLabel = ' evaluación'
          }

          $scope.compare = (list, item) => {
            let arr = list.map((wp) => {
              return angular.equals(wp, item)
            })
            return arr.includes(true)
          }

          function close () {
            $mdDialog.hide()
          }

          function associatePlanToCriterias (header) {
            WorkPlanParametrizationSrv.associatePlanToCriterias.associate(header).$promise.then((dataReturn) => {
              if (dataReturn.status === true) {
                $scope.criteriaList.forEach((list) => {
                  if (list.id_list === header.id_list) {
                    $scope.workplans.forEach((plan) => {
                      if (plan.id_work_plan === header.id_work_plan &&
                        !$scope.contains(list.workplans, plan)) {
                        list.workplans.push(plan)
                      }
                    })
                  } else {
                    list.workplans.forEach((plan, idx) => {
                      if (plan.id_work_plan === header.id_work_plan && $scope.contains(list.workplans, plan)) {
                        list.workplans.splice(idx, 1)
                      }
                    })
                  }
                })
                $mdDialog.hide()
              } else {
                $scope.isDisabled = false
              }
            })
          }

          function postAssociation () {
            $scope.isDisabled = true
            let newAssociation = {
              id_category: $scope.category,
              id_list: $scope.listing.id_list,
              id_work_plan: $scope.plans.id_work_plan
            }
            associatePlanToCriterias(newAssociation)
          }
        }],
        template: require('./associateCriteriaModal.html'),
        clickOutsideToClose: true
      })
    };

    function associatedPlans (list) {
      let currentCategory = categoryId
      $mdDialog.show({
        controller: ['$scope', '$mdDialog' ,function associatedPlansModal ($scope, $mdDialog) {
          $scope.currentCategory = currentCategory
          $scope.checkIsInicializated = checkIsInicializated
          $scope.checkIsInicializatedWorkPlan = checkIsInicializatedWorkPlan
          if (currentCategory === '1') {
            $scope.modalName = 'revisión/aprobación'
          } else {
            $scope.modalName = 'evaluación'
          }
          $scope.list = list
          $scope.close = () => {
            $mdDialog.hide()
            $state.reload()
          }
          $scope.disassociate = (index, workplan) => {
            var hasActives = false;
            let workplansInitiated = []
            var id_list = $scope.list.id_list
            var id_type_list = $scope.list.id_type_list
            var list = $scope.list
            
            $mdDialog.show({
                    controller: ['$scope', '$mdDialog' ,function ($scope, $mdDialog) {                     
                      $scope.workplanName = workplan.workplan_name 
                      $scope.id_list = id_list
                      $scope.id_type_list = id_type_list
                      $scope.list = list
                      $scope.disassociateWorkPlan = ()=>{
                        WorkPlanParametrizationSrv.disassociateCriteria.disassociate({
                            id_work_plan: workplan.id_work_plan,
                            id_list: $scope.id_list,
                            id_category: $scope.id_type_list
                          })
                          .$promise.then((dataReturn) => {
                            if (dataReturn.status === true) {
                              associateToDefaultSet($scope.list.workplans[index])
                              $scope.list.workplans.splice(index, 1)
                              $mdDialog.hide()
                              $state.reload()
                            }
                          })
                      }
                      $scope.close = () => {
                        $mdDialog.hide()
                      }
                    }],
                    template: require('./deleteConfirmationModalWorkplan.html'),
                    clickOutsideToClose: true
            })
          }
        }],
        template: require('./associatedPlansModal.html'),
        clickOutsideToClose: false
      })
    };

    function confirmDeleteCriteriaList (list, criteriaListId, criteriaListName, categoryTypeListId) {
      let criteriaList = criteriaListVM.criteriaList
      let updateView = criteriaListVM.updateView
      let workplansInitiated = []      

      //Revisa si tiene planes activos
      var tieneActivos = false;
      
      var workpl = []; //Empty array
      workpl = list.workplans;
      
      var dateToday = $filter('date') (new Date(), 'yyyy-MM-dd');
      for (var i=0; i<workpl.length; i++) {
        var dateStart = $filter('date') (workpl[i].start_date, 'yyyy-MM-dd');        

        //Si la fecha es menor o igual a fecha actual, entonces está activo y no se puede eliminar.
        if (dateStart <= dateToday) {
          tieneActivos = true;
          workplansInitiated.push(workpl[i]);
        }
      }

      if(tieneActivos === false)
      {
          $mdDialog.show({
            controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
              $scope.updateView = updateView
              $scope.criteriaList = criteriaList
              $scope.criteriaListId = criteriaListId
              $scope.criteriaListName = criteriaListName
              $scope.categoryTypeListId = categoryTypeListId
              $scope.close = () => {
                $mdDialog.hide()
              }

              $scope.deleteCriteriaList = (criteriaListId, categoryTypeListId) => {
                WorkPlanParametrizationSrv.deleteCriteriaListItem.delete({
                  id_list: criteriaListId,
                  id_category: categoryTypeListId
                })
                .$promise
                .then((dataReturn) => {
                  if (dataReturn.status === true) {
                    $scope.criteriaList.forEach((list, index) => {
                      if (list.id_list === criteriaListId) {
                        associateToDefaultSet(list.workplans)
                        $scope.criteriaList.splice(index, 1)
                      }
                    })
                    updateView()
                    $mdDialog.hide()
                    showCriteriaListDeletedModal(criteriaListName)
                  }
                }, (data) => { 
                  console.log(data)
                })
              }
            }],
            template: require('./deleteConfirmationModal.html'),
            clickOutsideToClose: true
          })
      }
      else
      {        
        //Show modal with validation message
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
              $scope.updateView = updateView
              $scope.criteriaList = criteriaList
              $scope.criteriaListId = criteriaListId
              $scope.criteriaListName = criteriaListName
              $scope.categoryTypeListId = categoryTypeListId              
              $scope.workplansInitiated = workplansInitiated
              $scope.close = () => {
                $mdDialog.hide()
              }
            }],
            template: require('./noDeletePlanInitiatedModal.html'),
            clickOutsideToClose: true
          })
      }
    }
  

    function showCriteriaListDeletedModal (criteriaListName) {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.criteriaListName = criteriaListName
          $scope.close = () => {
            $mdDialog.hide()
          }
        }],
        template: require('./deleteCriteriaListModal.html'),
        clickOutsideToClose: true
      })
    }

    function itemIsAlreadyAdded (item, items, criteriaDescription) {
      for (var pos in items) {
        console.log(items[pos].lists_item_name.toLowerCase(), items)
        console.log(criteriaDescription)
        if (items[pos].lists_item_name.toLowerCase().replace(/ /g, '')
          === item.toLowerCase().replace(/ /g, '') && items[pos].ds_description == criteriaDescription) {
          return true
        }
      }
      return false
    }

    function checkIsInicializated(criteria, fastQuit)
    {
      var hasActive = false
      criteriaListVM.workplansInitiated = []; //Empty array
      var workpl = criteria.workplans
      var dateToday = $filter('date') (new Date(), 'yyyy-MM-dd');
      for (var i=0; i<workpl.length; i++) {
        var dateStart = $filter('date') (workpl[i].start_date, 'yyyy-MM-dd');        
        //Si la fecha es menor o igual a fecha actual, entonces está activo y no se puede eliminar.
        if (dateStart <= dateToday) {
          hasActive = true;
          if(fastQuit){
            return hasActive
          }
          criteriaListVM.workplansInitiated.push(workpl[i])
        }
      }
      return hasActive
    }
    
    function checkIsInicializatedWorkPlan(workPlan)
    {
      var dateToday = $filter('date') (new Date(), 'yyyy-MM-dd');
      var dateStart = $filter('date') (workPlan.start_date, 'yyyy-MM-dd');        
      //Si la fecha es menor o igual a fecha actual, entonces está activo y no se puede eliminar.
      if (dateStart <= dateToday) {
        return false
      }
      return true
    }

  // INTIALIZATION
    activate(categoryId)
  }
}

CriteriaListViewCtrl.$inject = ['$scope', '$resource', '$stateParams', 'WorkPlanParametrizationSrv', '$mdDialog', '$timeout', '$state','$window', '$filter']


// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/criteria/criteriaListViewCtrl.js